import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";

import "./styles/globals.css"; // Tailwind entry + Kearney @theme (shell/apps)
import "./styles/v1-login.css"; // v1 Login tokens — kept OUT of the Tailwind entry (see file headers)
import { App } from "./App";
import { queryClient } from "./lib/queryClient"; // 0.7 — app-wide TanStack Query

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
